import { render, staticRenderFns } from "./SampleGadgetV3.vue?vue&type=template&id=10bc0828&scoped=true&"
import script from "./SampleGadgetV3.vue?vue&type=script&lang=ts&"
export * from "./SampleGadgetV3.vue?vue&type=script&lang=ts&"
import style0 from "./SampleGadgetV3.vue?vue&type=style&index=0&id=10bc0828&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10bc0828",
  null
  
)

export default component.exports